// extracted by css-extract-rspack-plugin
export default {"page":"DMUyo","frame":"uSxNB"};